import { useEffect } from 'react';
import { organizationSchema } from '../../constants/organizationSchema';

const ORG_SCRIPT_ID = 'global-organization-jsonld';
const WEBSITE_SCRIPT_ID = 'global-website-jsonld';

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  '@id': 'https://musthost.com.br/#website',
  name: 'musthost',
  alternateName: 'musthost LTDA',
  url: 'https://musthost.com.br',
  description:
    'VPS de alta performance para traders, desenvolvedores e empresas desde 2008. Data centers no Brasil, Reino Unido e EUA.',
  inLanguage: 'pt-BR',
  publisher: {
    '@type': 'Organization',
    '@id': 'https://musthost.com.br/#organization',
  },
  potentialAction: {
    '@type': 'SearchAction',
    target: {
      '@type': 'EntryPoint',
      urlTemplate: 'https://musthost.com.br/busca?q={search_term_string}',
    },
    'query-input': 'required name=search_term_string',
  },
};

function injectSchema(id: string, data: object) {
  if (document.getElementById(id)) return;
  const script = document.createElement('script');
  script.type = 'application/ld+json';
  script.id = id;
  script.textContent = JSON.stringify(data);
  document.head.appendChild(script);
}

export default function GlobalOrganizationSchema() {
  useEffect(() => {
    injectSchema(ORG_SCRIPT_ID, organizationSchema);
    injectSchema(WEBSITE_SCRIPT_ID, websiteSchema);
  }, []);

  return null;
}